import { Routes, Route, Navigate } from "react-router-dom";
import { KuizyThemeProvider } from "@/styles/kuizyTheme";
import RequireAuth from "@/layout/RequireAuth";
import KuizyLayout from "@/layout/KuizyLayout";
import LoginPage from "@/pages/authentication/LoginPage";
import RegisterPage from "@/pages/authentication/RegisterPage";
import FullScreenQR from "@/widgets/FullScreenQR";
import ContentPage from "@/pages/ContentPage";
import LessonsPage from "@/pages/LessonsPage";
import LessonDetailPage from "@/pages/LessonDetailPage"
import QuestionBankPage from "@/pages/QuestionBankPage";
import TestListPage from "@/pages/TestListPage";
import TestBuilderPage from "@/pages/TestBuilderPage";
import CreateExamPage from "@/pages/CreateExamPage";
import UploadContentPage from "@/pages/UploadContentPage";
import LessonManagePage from "@/pages/LessonManagePage";
import ClassListPage from "@/pages/class/ClassListPage";
import GroupListPage from "@/pages/admin/GroupListPage";
import LearnersListPage from '@/pages/admin/LearnersListPage';
import ConfirmSignupPage from "@/pages/authentication/ConfirmSignupPage";
import SignupVerifyPage from '@/pages/authentication/SignupVerifyPage'
import ForgotPasswordPage from "@/pages/authentication/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/authentication/ResetPasswordPage";
import InviteSignupPage from "@/pages/authentication/InviteSignupPage";
import InviteActivatePage from "./pages/authentication/AcceptInvite";
import HomePage from "@/pages/HomePage";
import OrganizationInfo from "@/pages/admin/OrganizationInfoPage";
import RolesPage from "@/pages/admin/RolesPage";
import CourseApproverManagementPage from "@/pages/admin/CourseApproverManagementPage";
// import ExamApproverManager from "@/pages/admin/ExamApproverManager";
import LessonExamBuilder from "@/pages/LessonExamBuilder";
import CourseListPage from "./pages/class/CourseListPage";
import CourseTestApprovalPage from "./pages/class/CourseTestApprovalPage";
import UserProfilesPage from "./pages/admin/UserProfilesPage";
import CreatorCoursesPage from "./pages/class/CreatorCoursesPage";
import DashboardPage from "./pages/DashboardPage";
import PublicExamJoin from "./pages/players/PublicExamJoin";
import PublicExamPlay from "./pages/players/PublicExamPlay";
import PublicExamResult from "./pages/players/PublicExamResult";

import SessionExpiryGate from "@/components/SessionExpiryGate";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import SubscriptionPage from "@/pages/SubscriptionPage";
import NotFoundPage from "@/pages/NotFoundPage";
import LearnerHomePage from "./pages/learners/LearnerHomePage";
import LearnerCoursePage from "./pages/learners/LearnerCoursePage";
import LearnerContentPage from "./pages/learners/LearnerContentPage";
import LearnerContentDetailPage from "./pages/learners/LearnerContentDetailPage";
import LearnerResetPasswordPage from "./pages/learners/LearnerResetPasswordPage";
import LearnerExamPlay from "@/pages/learners/LearnerExamPlay";
import LearnerExamResult from "./pages/learners/LearnerExamResult";
import LearnerExamEntry from "@/pages/learners/LearnerExamEntry";

import DeclinePage from "@/pages/authentication/DeclinePage"
import ReportsPage from '@/pages/admin/ReportsPage'
import ReportLearnerPage from '@/pages/admin/ReportLearnerPage'
import AdminLearnerPortal from "@/pages/admin/AdminLearnerPortal";

import PricingPage from "@/pages/PricingPage"


export default function App() {
  return (
    <KuizyThemeProvider>
      <div className="font-sans bg-white text-gray-800 overflow-x-hidden">
        <SessionExpiryGate />
        <Routes>
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/first-login/:token" element={<InviteActivatePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/kuizy-qrcode/:encodedorgId/:encodedTestRunId" element={<FullScreenQR />} />
          <Route path="/play/:orgId/:runId" element={<PublicExamJoin />} />
          <Route path="/play/:orgId/:runId/exam" element={<PublicExamPlay />} />
          <Route path="/play/:orgId/:runId/result/:sid" element={<PublicExamResult />} />

          <Route path="/confirm/:token" element={<ConfirmSignupPage />} />
          <Route path="/signup-verify/:token" element={<SignupVerifyPage />} />
          <Route path="/signup-verify" element={<SignupVerifyPage />} />

          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/invite/:token" element={<InviteSignupPage />} />

          <Route path="/learn" element={<LoginPage />} />
          <Route path="/learn/login" element={<LoginPage />} />
          <Route path="/learn/home" element={<LearnerHomePage />} />
          <Route path="/learn/course/:courseId" element={<LearnerCoursePage />} />
          <Route path="/learn/course/:courseId/content/:contentId" element={<LearnerContentDetailPage />} />
          <Route path="/learn/course/:courseId/play/:attachmentId" element={<LearnerContentPage />} />
          <Route path="/learn/reset-password/:token" element={<LearnerResetPasswordPage />} />

          <Route path="/learn/exam" element={<LearnerExamEntry />} />
          <Route path="/learn/exam/:runId" element={<LearnerExamPlay />} />
          <Route path="/learn/exam/result/:runId" element={<LearnerExamResult />} />

          <Route path="/decline/:type/:token" element={<DeclinePage />} />

          <Route
            element={
              <RequireAuth>
                <SubscriptionProvider>
                  <KuizyLayout />
                </SubscriptionProvider>
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="/login" replace />} />
            <Route path="player" element={<HomePage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="/user-profiles" element={<UserProfilesPage />} />

            <Route path="content" element={<ContentPage />} />
            <Route path="content/:cid" element={<LessonDetailPage />} />
            <Route path="content/:cid/lessons" element={<LessonsPage />} />
            <Route path="content/:cid/lessons/:lid" element={<QuestionBankPage />} />
            <Route path="content/:cid/lessons/:lid/bank" element={<QuestionBankPage />} />
            <Route path="content/:cid/lessons/:lid/create-exam" element={<CreateExamPage />} />
            <Route path="content/:cid/create-exam" element={<LessonExamBuilder />} />
            <Route path="content/:cid/lessons/:lid/upload-content" element={<UploadContentPage />} />
            <Route path="content/:cid/lessons/:lesson_id/manage" element={<LessonManagePage />} />
            <Route path="tests" element={<TestListPage />} />
            <Route path="content/:cid/tests" element={<TestListPage />} />
            <Route path="content/:cid/tests/new" element={<TestBuilderPage />} />
            <Route path="content/:cid/lessons/:lid/tests/new" element={<TestBuilderPage />} />
            <Route path="tests/:tid/edit" element={<TestBuilderPage />} />
            <Route path="content/:cid/tests/:tid/edit" element={<TestBuilderPage />} />
            <Route path="content/:cid/lessons/:lid/tests/:tid/edit" element={<TestBuilderPage />} />

            <Route path="learners" element={<LearnersListPage />} />
            <Route path="class" element={<ClassListPage />} />
            <Route path="my-courses" element={<CreatorCoursesPage />} />
            <Route path="course" element={<CourseListPage />} />
            <Route path="course/approvals" element={<CourseTestApprovalPage />} />
            <Route path="content/:cid/class" element={<ClassListPage />} />
            <Route path="group" element={<GroupListPage />} />
            <Route path="role" element={<RolesPage />} />
            <Route path="approver" element={<CourseApproverManagementPage />} />
            <Route path="organization" element={<OrganizationInfo />} />
            <Route path="subscription" element={<SubscriptionPage />} />

            <Route path="/learners/reports-results" element={<ReportsPage />} />
            <Route path="/learners/report" element={<ReportLearnerPage />} />
            <Route path="learn/portal" element={<AdminLearnerPortal />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </KuizyThemeProvider>
  );
}
